import { PropositionButtonSchema } from '@/views/sports/components/PropositionButton/styles/PropositionButton.styles';

export const propositionButtonStyles: PropositionButtonSchema = {
  buttonBase: {
    fontSize: '2xs',
    lineHeight: '1.125',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    sx: {
      '&&': {
        minW: '20',
      },
    },
  },
  buttonBaseSpanProps: {
    overflow: 'hidden',
    pos: 'relative',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    alignSelf: 'center',
    color: 'blackAlpha700',
    textTransform: 'capitalize',
  },
  buttonBaseBox: {
    fontSize: 'sm',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.45)',
    fontWeight: 'black',
    color: '#255505',
  },
  textBase: {
    textAlign: 'center',
    color: 'beta.600',
  },
};
